export default __webpack_public_path__ + "static/media/SWT0020.34I-21284_-15285_0.40cb33fc.jpg";